// @flow
import * as React from 'react'
import Text from 'ui/atoms/Text'
import Title from 'ui/atoms/Title'
import TitleWrapper from 'ui/atoms/TitleWrapper'

type Props = {
  action?: React.Node,
  center?: boolean,
  text?: string,
  component?: React.Node,
  subText?: string,
  translate?: 'no',
  className?: string,
}

function PageTitle({
  action,
  center,
  text,
  subText,
  component,
  translate,
  className,
}: Props): React.Node {
  return (
    <TitleWrapper $center={center} className={className}>
      {text && (
        <Title $inline={Boolean(action)} translate={translate}>
          {text}
        </Title>
      )}
      {component ? component : null}
      {action ? action : null}
      {subText && <Text translate={translate}>{subText}</Text>}
    </TitleWrapper>
  )
}

export default PageTitle
